import { AuthProviderProps } from "react-oidc-context";

export const getOIDCConfig = (authority: string, client_id: string) : AuthProviderProps => ({
  authority,
  client_id,
  redirect_uri: window.location.origin,
  onSigninCallback: () => {
    // Remove the query parameters when redirected back
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  // Enable silent authentication
  automaticSilentRenew: true,
  loadUserInfo: true,
  scope: "openid profile email organization",
});
